<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="fangyicontain">
            <div style="margin: 0 auto;">
                <div style="height: 532px;background: url('http://p1.fishqc.net/Fiy05vF4Q-K-sG1JytNOSBaonsNx') center center no-repeat;background-size: auto 100%;">
                    <div class="logocontain">
                        <img src="http://p1.fishqc.net/FgvNtCTpT8L6EP0D7tIIaYCNodQG" class="logo"><img src="http://p1.fishqc.net/FiQo6NvX-mr44_-kTvvDWqWpxoqT" class="fishqclogo">
                    </div>
                </div>
                <div style="height: 4187px;background: url('http://p1.fishqc.net/FnwNc7XPoPtQ_ECAgWJB2FJXz1UE') center center no-repeat;background-size: auto 100%;margin-top: -1px">
                    <div class="mumcontain">
                        <div style="padding-bottom: 37px;">
                            <img src="http://p1.fishqc.net/FhU5hdeFZ9r7PBqRp2-SNJsmL3YD">
                        </div>
                        <div v-for="item in productdata" class="">
                            <div :class="['product',item.class]" @click="toproductdetail(item.type,item.id)">
                                <img src="http://p1.fishqc.net/FpRabjIY4QI8btZvP0wShvPKcVvf" :class="['leftimg',item.id == 'pENF2Fy8G-uql2Q_xux6rQ'?'leftimg1':'']"></img>
                                <img src="http://p1.fishqc.net/Flt0YxGxLWEJKc-6INxbVNOwTzH4" class="rightimg"></img>
                                <div :class="['content',item.contentclass]">
                                    <div class="brand">{{item.brand}}</div>
                                    <div class="title1"><span>{{item.title}}</span> <span class=" title2">{{item.title2}}</span>
                                    </div>
                                    <div>
                                        <span class="inline-block tips">{{item.tips}}</span>
                                        <span class="inline-block address">品牌所在地：{{item.address}}</span>
                                    </div>
                                </div>
                                <div :class="['desc',item.id == 'pENF2Fy8G-uql2Q_xux6rQ'?'desc1':'',item.id == 'H1RwxIoptj0LO0Tiasdtbg'?'desc2':'']">{{item.desc}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="height: 2368px;background: url('http://p1.fishqc.net/FqSm7sxJPYv13fhpAWlgqc2tAon3') center center no-repeat;background-size: auto 100%;padding-top:40px;box-sizing: border-box;margin-top: -1px">
                    <div class="mumcontain">
                        <div style="padding-bottom: 140px;">
                            <img src="http://p1.fishqc.net/FlJSAyvTlaxAcWpdcTnsDE5AZl14">
                        </div>
                        <div class="box">
                            <img src="http://p1.fishqc.net/FsPwnL0ArElP5mKdlfaSWbKrYtVA" class=" section2"></img>
                            <div class="boxdesc">绿鱼妈妈亲测榜是妈妈网联合小鱼亲测特别策划的，为妈妈甄选值得信赖的口碑好物的美妆榜单，采用小鱼亲测应用“诺贝尔奖”的权威检测科技以及多维专业母婴测评，旨在打造在孕妈宝妈心中代表安全品质的妈妈美妆品牌榜单。
                            </div>
                            <img src="http://p1.fishqc.net/FpAKtflRdfXN837h7JTzuKboUS9S" class=" girlfish"></img>
                            <img src="http://p1.fishqc.net/Fj0kh9PNEBkeE5iQE3NDdW-R50Jj" class=" flow"></img>
                        </div>
                        <div style="padding-top: 100px;">
                            <img src="http://p1.fishqc.net/FgvNtCTpT8L6EP0D7tIIaYCNodQG" class="logo1"><img src="http://p1.fishqc.net/FiQo6NvX-mr44_-kTvvDWqWpxoqT" class="fishqclogo1">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.about_menu_top {
    margin: 100px auto 0;

}

.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 998px;
    margin:0 auto;
    display: block;
    text-align: center;
    padding-top: 10px;
}

.techcover{
    padding-bottom:60px;
}

.listitem{
    padding:26px 26px 0px;
    box-sizing: border-box;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:32px;
    border:8px solid rgba(35, 181, 171, 1);
    border-radius:0px 24px 24px 24px;
    margin-bottom: 60px;
    background-color: #fff;
}

.listitem1{
    margin-bottom:48px;
}
.padding-bottom-24{
    padding-bottom:24px;
    box-sizing: border-box;
    text-align: left;
}

.productdetailcontain{
    flex:1;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 255px;
    vertical-align: top;
    margin-bottom: 32px;
    cursor: pointer;
    border-radius:24px;
    box-shadow: 0 0 12px rgba(157,221,214,0.2);
    padding:25px 20px;
    box-sizing: border-box;

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n){
    margin-right: 0px;
}

.imgcontain{
    width: 154px;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}

.logocontain{
    padding:31px 0 0 50px;
    box-sizing: border-box;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}

.logo{
    width:85px;
    height: 34px;
    margin-right: 53px;
    vertical-align: middle;
}
.logo1{
    width:124px;
    height: 51px;
    vertical-align: middle;
    margin-right: 105px;
}
.fishqclogo{
    width:123px;
    height: 34px;
    vertical-align: middle;
}
.fishqclogo1{
    width:153px;
    height: 42px;
    vertical-align: middle;
}
.padding-10{
    padding-top:10px;
}

.leftimg{
    width:146px;
    height:124px;
    position: absolute;
    bottom:106px;
    left:55px;
}

.leftimg1{
    bottom:80px;
}

.rightimg{
    width:79px;
    height:53px;
    position: absolute;
    bottom:40px;
    right:60px;
}
.product{
    display:inline-block;
    position: relative;
    cursor: pointer;
}
.class1{
    width:898px;
    height:458px;
    margin-bottom:72px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/Ft5zb6W97iK-COoniFYM5uPzVRBh);
}

.class2{
    width:883px;
    height:491px;
    margin-bottom:45px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/FrYKq53G4PtGqGtd9c_ovR_nGRDn);
}
.class3{
    width:885px;
    height:522px;
    margin-bottom:57px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/Fl4AcE62iSJDNPbpjGrROERRaMa7);
}
.class4{
    width:881px;
    height:518px;
    margin-bottom:77px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/FoAaeB1FwAOIxTnPKWqrVodeARbK);
}
.class5{
    width:880px;
    height:525px;
    margin-bottom:64px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/Fupy6wxWykqCf-8NjcNvLGNmM5Mk);
}
.class6{
    width:885px;
    height:535px;
    margin-bottom:63px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/FjMaab1V7Gvncg7DR6Q9vsNTvPAb);
}
.class7{
    width:881px;
    height:515px;
    margin-bottom:102px;
    background-repeat: no-repeat;
    background-size:100%;
    background-image:url(http://p1.fishqc.net/Fh9piEnILqBUlaIba23mYENYZIdk);
}

.box{
    background:rgba(255,255,255,1);
    border:7px solid rgba(81, 213, 250, 1);
    border-radius:24px;
    padding:64px 99px 72px 88px;
    text-align:center;
    position: relative;
    background-color:#fff;
}

.section2{
    width:359px;
    height:52px;
    display:block;
    margin:0 auto;
    
}

.boxdesc{
    text-align:left;
    padding-top:25px;
    text-indent:64px;
    font-size:32px;
    font-family:Source Han Sans SC;
    font-weight:400;
    color:rgba(99,91,91,1);
    line-height:43px;
}
.girlfish{
    width:185px;
    height:218px;
    position: absolute;
    left:-13px;
    top:-46px;
}

.flow{
    width:124px;
    height:145px;
    position: absolute;
    right:22px;
    bottom:-30px;
}

.brand{

    font-size:38px;
    font-family:Alibaba PuHuiTi;
    font-weight:500;
    color:rgba(2,132,193,1);
    line-height:35px;
    padding-bottom: 6px;
}

.title1{
    font-size:34px;
    font-family:Alibaba PuHuiTi;
    font-weight:500;
    color:rgba(2,132,193,1);
    line-height:40px;
    padding-bottom: 12px;
}

.title2{
    padding-top:8px;
    padding-bottom:20px;
    padding-left: 14px;
    font-size:28px;
    font-family:Alibaba PuHuiTi;
    font-weight:500;
    color:rgba(1,151,210,1);
    line-height:40px;
}

.desc{
    width:600px;
    
    position: absolute;
    right:63px;
    bottom:85px;
    text-align:left;

    font-size:24px;
    font-family:Source Han Sans SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:36px;
}
.desc1{
    bottom:96px;
}
.desc2{
    bottom:108px;
}
.content{
    width:76%;
    font-family:Alibaba PuHuiTi;
    text-align:left;
    position: absolute;
    left:300px;
    top:22px;
}

.contentclass1{
    top:35px;
}

.contentclass2{
    top: 22px;
}
.contentclass3{
    top: 72px;
}
.contentclass4{
    top: 54px;
}

.contentclass5{
    top:46px;
}
.contentclass6{
    top:50px;
}
.contentclass7{
    top:44px;
}
.tips{
    font-size:26px;
    font-family:Source Han Sans SC;
    font-weight:400;
    color:rgba(233,253,255,1);
    line-height:27px;
    padding:0 12px;
 
    line-height:36px;
    vertical-align:middle;
    margin-right:20px;

    height:36px;
    background:linear-gradient(0deg,rgba(112,213,141,1) 0%,rgba(37,196,219,1) 100%);
    border-radius:16px;
}

.address{
    font-size:24px;
    font-family:Alibaba PuHuiTi;
    font-weight:400;
    color:rgba(11,164,225,1);
    line-height:31px;
    vertical-align:middle;
    padding-left:23px;
    background-repeat: no-repeat;
    background-size:18px 23px;
    background-image:url('http://p1.fishqc.net/FkLJzWIgXSY9TNprJyOO5u31m4cB');
    background-position:left center;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
                {
                    class:'class1',
                    contentclass:'contentclass1',
                    brand:'ISDIN怡思丁',
                    title:'多维光护沁融水感防晒液',
                    title2:'SPF50+',
                    tips:'水感清透',
                    address:'西班牙',
                    desc:'这款防晒属于物理+化学防晒，且添加保湿成分，无酒精刺激。成膜后就像没涂一样很清爽，很好推开，成膜很快，妥妥的隐形防晒衣。',
                    type:'cosmetic',
                    id:'pENF2Fy8G-uql2Q_xux6rQ',

                },
                {
                    class:'class2',
                    contentclass:'contentclass2',
                    brand:'ANESSA安热沙',
                    title:'金钻防晒霜',
                    title2:'SPF50+ PA++++',
                    tips:'经典之王',
                    address:'日本',
                    desc:'这款防晒属于物理+化学防晒，成膜速度快、持续效果久，防水防汗抗摩擦，是防晒中的扛把子。夏天涂上它你就是沙滩上最靓的崽。但是这款产品有轻微的酒精味，皮肤比较敏感的话要注意哦。',
                    type:'cosmetic',
                    id:'cB2FgmQEHHzA32fRRt1_Tw',

                },
                {
                    class:'class3',
                    contentclass:'contentclass3',
                    brand:"L'OREAL PARIS巴黎欧莱雅",
                    title:'多重防护城市水活隔离噴雾',
                    title2:'SPF 42 PA++++',
                    tips:'一喷成膜',
                    address:'法国',
                    desc:'这款防晒属于化学防晒，含有专属麦色滤防晒成分，有效过滤紫外线，可以防水防汗不花妆。喷雾细腻均匀，使用起来几乎没有任何粘腻感，还可以带妆使用，超合适日常带妆的妈妈们！',
                    type:'cosmetic',
                    id:'m0y5kZo-ICWELyBMy-4TQQ',

                },
                {
                    class:'class4',
                    contentclass:'contentclass4',
                    brand:'BIORE碧柔',
                    title:'Aqua Rich 水凝长效保湿防晒乳',
                    title2:'SPF50+',
                    tips:'水活防晒',
                    address:'日本',
                    desc:'这款防晒属于化学防晒，添加多种保湿成分，可以减缓肌肤水分被晒干。涂上脸后水润不干燥，很适合干皮妈妈使用，还可以作为妆前底霜，让妆容更加持久，早上又可以多睡一分钟！',
                    type:'cosmetic',
                    id:'-3KwkJNVMQURNyropolQLA',

                },
                {
                    class:'class5',
                    contentclass:'contentclass5',
                    brand:'NIVEA妮维雅',
                    title:'水感防日光保湿啫喱 ',
                    title2:'SPF50 PA+++',
                    tips:'平价大碗',
                    address:'日本',
                    desc:'这款防晒属于化学防晒，质地轻薄水润，无添加香料，无着色。上脸后水润不油腻，保湿力强，平价大碗超适合身体防晒！',
                    type:'cosmetic',
                    id:'H1RwxIoptj0LO0Tiasdtbg',

                },
                {
                    class:'class6',
                    contentclass:'contentclass6',
                    brand:'W.LAB',
                    title:'水光防晒啫喱',
                    title2:'SPF50+ PA+++',
                    tips:'亲肤不刺激',
                    address:'韩国',
                    desc:'这款防晒属于物理+化学防晒，含有植物无泪配方，适合敏感肌使用。质地水润不厚重，容易推开涂抹，上脸轻薄保湿，需要注意的就是香味较浓，对香味比较敏感、不喜欢浓郁香味的妈妈可以考虑其他的。',
                    type:'cosmetic',
                    id:'Nqw0kWdD4dRoBJNe03PMxg',

                },
                {
                    class:'class7',
                    contentclass:'contentclass7',
                    brand:'DECORTE黛珂 ',
                    title:'多重防晒乳 ',
                    title2:'SPF50 PA+++',
                    tips:'水润养肤',
                    address:'日本',
                    desc:'这款防晒属于物理+化学防晒，含有保湿与抗氧化成分，养肤防晒一手抓。上脸后不泛白不搓泥，使用感不错，比较特别的是它还含有防雾霾成分，可以说是很适合日常通勤使用了。',
                    type:'cosmetic',
                    id:'b64OKxCsDJ_HEfG3t5woQg',

                }
            ],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type, prdid) {
            this.$router.push({
                path: '/product/' + type + '/' + prdid
            })

        }
    }
}
</script>